import React from 'react';

import classes from './Main.scss';

type MainProps = Record<string, unknown>;

export const Main: React.FC<MainProps> = React.memo((props) => {
    return (
        <main className={classes.root} id="content">
            {props.children}
        </main>
    );
});
